/* eslint-disable no-underscore-dangle */
import { message } from 'antd';
import actions from './actions';
import axios from '../axios';
import store from '../store';
import errorHandling from '../error';
import { getHeaders } from '../../utils/common';

const {
  getFeaturesCategoryBegin,
  getFeaturesCategorySuccess,
  getFeaturesCategoryFailed,
  addFeaturesCategoryBegin,
  addFeaturesCategorySuccess,
  addFeaturesCategoryFailed,
  updateFeaturesCategoryBegin,
  updateFeaturesCategorySuccess,
  updateFeaturesCategoryFailed,
  deleteFeaturesCategoryBegin,
  deleteFeaturesCategorySuccess,
  deleteFeaturesCategoryFailed,
  deleteFeaturesBegin,
  deleteFeaturesFailed,
} = actions;

// GETTING ALL CATEGORIES
export const getAllFeaturesCategory = async dispatch => {
  try {
    dispatch(getFeaturesCategoryBegin());
    const res = await axios.get('feature-categories', { headers: { ...getHeaders() } });
    dispatch(getFeaturesCategorySuccess(res.data.featureCategories));
    return res;
  } catch (err) {
    dispatch(getFeaturesCategoryFailed(err.response.data.msg));
    dispatch(errorHandling(err, false));
    return err;
  }
};

// ADDING NEW CATEGORY
export const addNewFeaturesCategory = data => async dispatch => {
  try {
    const state = store.getState();
    dispatch(addFeaturesCategoryBegin());
    const res = await axios.post('feature-categories', data, { headers: { ...getHeaders() } });
    const newCategories = [res.data.featureCategory, ...state.featuresCategory.featuresCategory];

    dispatch(addFeaturesCategorySuccess(newCategories));
    message.success('New catrgory created successfully');
    return res;
  } catch (err) {
    dispatch(addFeaturesCategoryFailed(err?.response?.data?.msg));
    return err;
  }
};

// UPDATING CATEGORY BY ID
export const editFeaturesCategory = (id, datas) => async dispatch => {
  try {
    const state = store.getState();
    dispatch(updateFeaturesCategoryBegin());
    const res = await axios.put(`feature-categories/${id}`, datas, { headers: { ...getHeaders() } });
    const newCategories = state.featuresCategory.featuresCategory.map(category => {
      if (category._id === id) return res.data.featureCategory;
      return category;
    });

    dispatch(updateFeaturesCategorySuccess(newCategories));
    message.success('Car color updated successfully');
    return res;
  } catch (err) {
    message.error(err?.response?.data?.error || err?.response?.data?.msg || 'Something went wrong');

    dispatch(updateFeaturesCategoryFailed(err?.response?.data?.error || err?.response?.data?.msg));
    return err;
  }
};

// DELETE CATEGORY BY ID
export const deleteFeatureCategory = id => async dispatch => {
  try {
    const state = store.getState();
    dispatch(deleteFeaturesCategoryBegin());
    const res = await axios.delete(`feature-categories/${id}`, { headers: { ...getHeaders() } });

    dispatch(
      deleteFeaturesCategorySuccess(state.featuresCategory.featuresCategory.filter(category => category._id !== id)),
    );
    message.success('Feature category deleted successfully');
    return res;
  } catch (err) {
    message.error(err?.response?.data?.error || err?.response?.data?.msg || 'Something went wrong');
    dispatch(deleteFeaturesCategoryFailed(err?.response?.data?.error || err?.response?.data?.msg));
    return err;
  }
};

// ADDING NEW CATEGORY
export const addNewFeatures = async data => {
  try {
    const res = await axios.post('features', data, { headers: { ...getHeaders() } });
    if (res.data.status) {
      message.success('Added New feature successfully');
    }
    return res;
  } catch (err) {
    message.error(err?.response?.data?.error || err?.response?.data?.msg || 'Something went wrong');

    return err;
  }
};

// UPDATING CATEGORY BY ID
export const editFeatures = async (id, datas) => {
  try {
    const res = await axios.put(`features/${id}`, datas, { headers: { ...getHeaders() } });
    if (res.data.status) {
      message.success('Feature updated successfully');
    }
    return res;
  } catch (err) {
    message.error(err?.response?.data?.error || err?.response?.data?.msg || 'Something went wrong');

    return err;
  }
};

// DELETE FEATURE BY ID
export const deleteFeature = id => async dispatch => {
  try {
    dispatch(deleteFeaturesBegin());
    const res = await axios.delete(`features/${id}`, { headers: { ...getHeaders() } });
    message.success('Feature deleted successfully');
    return res;
  } catch (err) {
    message.error(err?.response?.data?.error || err?.response?.data?.msg || 'Something went wrong');
    dispatch(deleteFeaturesFailed(err?.response?.data?.error || err?.response?.data?.msg));
    return err;
  }
};
